import { EditOutlined, RedoOutlined } from '@ant-design/icons';
import { Button, Empty, List } from 'antd';
import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import settings from '../../../settings';
import { generateUuid } from '../../../shared/utils';
import EventReportListItem from './EventReportListItem';
import { useReports } from './use-reports';

const queryId = 'listTrainingEventReports';

function ListTrainingEventReports() {
  const { loading, data: reports, refetch } = useReports({}, queryId);

  const [numShown, setNumShown] = useState(settings.pageSize);
  const locale = useSelector((store) => store.locale, shallowEqual);
  return (
    <>
      <div style={{ display: 'flex', marginBottom: 8 }}>
        <Link to={`/training-reports/event/edit/${generateUuid()}`}>
          <Button icon={<EditOutlined />}>New Training Event Report</Button>
        </Link>
        <div style={{ flex: 1 }} />
        <Button icon={<RedoOutlined />} onClick={refetch}>
          Refresh
        </Button>
      </div>
      <List
        dataSource={reports.slice(0, numShown)}
        rowKey="_id"
        renderItem={(item) => (
          <EventReportListItem report={item} locale={locale} />
        )}
        loading={loading}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No reports"
            />
          ),
        }}
        loadMore={
          reports.length > numShown && (
            <div className="load-more">
              <Button onClick={() => setNumShown(numShown + settings.pageSize)}>
                Load More
              </Button>
            </div>
          )
        }
      />
    </>
  );
}

export default ListTrainingEventReports;
